import React from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Typography from '../../UniformComponents/Typography'
import OneByOneLayout from './layouts/1x1'
import TwoByOneLayout from './layouts/2x1'
import ThreeByOneLayout from './layouts/3x1'
import OneByTwoLayout from './layouts/1x2'
import FourByOneLayout from './layouts/4x1'
import TitleSlide from './layouts/TitleSlide'
import SectionHeader from './layouts/SectionHeader'
import TwoByTwoLayout from './layouts/2x2'
import Verbatim from './layouts/Verbatim'
import Derived from './layouts/Derived'
import Specification from './layouts/Specification'
import Inherited from './layouts/Inherited'
import Swot from './layouts/Swot'
import Summary from './layouts/Summary'
import CrossbreakLayout from './layouts/Crossbreak'
import LMX from './layouts/LMX'
import OSS from './layouts/OSS'

const TITLE_UNEDITABLE_TEMPLATES = ['title', 'verbatim']

const Slide = ({ store }) => {
    const {
        handleOpenSlideSettingsModal, deleteSlide, duplicateSlide,
    } = store

    const renderSlideLayout = () => {
        if (!store.activeSlide) return null

        switch (store.activeSlide?.template) {
            case '1x1':
                return <OneByOneLayout store={store} />
            case '2x1':
                return <TwoByOneLayout store={store} />
            case '2x2':
                return <TwoByTwoLayout store={store} />
            case '3x1':
                return <ThreeByOneLayout store={store} />
            case '1x2':
                return <OneByTwoLayout store={store} />
            case '4x1':
                return <FourByOneLayout store={store} />
            case 'verbatim':
                return <Verbatim store={store} />
            case 'derived':
                return <Derived store={store} />
            case 'crosstab':
                return <CrossbreakLayout store={store} />
            case 'title':
                return <TitleSlide store={store} />
            case 'lmx':
                return <LMX store={store} />
            case 'oss':
                return <OSS store={store} />
            case 'swot':
                return <Swot store={store} />
            case 'summary':
                return <Summary store={store} />
            case 'inherited':
                return <Inherited store={store} />
            case 'recommendations':
                return null
            case 'sectionHeader':
                return <SectionHeader store={store} />
            case 'specification':
                return <Specification store={store} />
            default:
                return null
        }
    }

    const isStyledSlide = ['title', 'verbatim'].includes(store.activeSlide?.template)
    const isTitleSlide = ['title', 'sectionHeader', 'specification', 'swot', 'summary'].includes(store.activeSlide?.template)
    const isNonChartSlideTitle = ['swot', 'summary'].includes(store.activeSlide?.template)
    const slideTitle = isNonChartSlideTitle ? store.activeSlide.title : store.activeSlideTitle

    return (
        <div className={`pp-slide ${isStyledSlide ? 'styled-slide' : ''} ${isTitleSlide ? 'pp-title-slide' : ''}`}>
            {!['title', 'sectionHeader'].includes(store.activeSlide?.template) && (
                <div className="pp-slide-title-container">
                    <div>
                        <Typography
                            type="tiny"
                            color="primary"
                        >
                            {store.activeSlideRespondentTypes}
                        </Typography>
                        <Typography
                            type="b"
                            color="white"
                        >
                            {slideTitle}
                        </Typography>
                    </div>

                    <img
                        src="https://cdn.explori.com/images/logo_explori.png"
                        alt="explori logo"
                        style={{ height: 30 }}
                    />
                </div>
            )}

            {renderSlideLayout()}

            <div className="pp-slide-controls">
                {!TITLE_UNEDITABLE_TEMPLATES.includes(store.activeSlide?.template) && (
                    <div className="pp-slide-edit" onClick={handleOpenSlideSettingsModal}>
                        <i className="fas fa-heading" />
                    </div>
                )}

                {!['title', 'sectionHeader', 'summary', 'sectionSummary'].includes(store.activeSlide?.template) && (
                    <div className="pp-slide-edit" onClick={duplicateSlide}>
                        <i className="fas fa-copy" />
                    </div>
                )}

                {store.activeSlide?.template !== 'title' && (
                    <div className="pp-slide-delete" onClick={() => deleteSlide('slide')}>
                        <i className="fas fa-trash" />
                    </div>
                )}
            </div>
        </div>
    )
}

export default observer(Slide)
